// @ts-nocheck
import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import {
  authHeaders,
  fmtDateTime,
  getLatestAppForJob,
  interviewEligibleForJob,
  interviewStartSlotStatus,
  formatInterviewCountdown,
  INTERVIEW_SLOT_CLOSED_MESSAGE,
  applicationEligibleForTechnicalReattemptRequest,
  applicationEligibleForRescheduleRequest,
  portalStatusLabel,
  SB,
  CANDIDATE_REATTEMPT_REASONS,
  CANDIDATE_RESCHEDULE_REASONS,
} from "@/legacy/helpersModule";
import { Badge } from "@/shared/components/ui/Badge";
import { Button, Select, Textarea, useToast } from "@/shared/components/ui";
export function CandDash({ candidate, jobs, portalFocusJobId, onPortalFocusJob, onApply, onTalentPool, onInterview, onRights, onLogout, talentPoolSelected, onSync, scheduleFlash = null }) {
  const toast = useToast();
  const focusJobId = portalFocusJobId || candidate.jobId;
  const jobIdsOrdered = (() => {
    const out = [];
    const seen = new Set();
    for (const a of candidate.applicationHistory || []) {
      if (a.jobId && !seen.has(a.jobId)) {
        seen.add(a.jobId);
        out.push(a.jobId);
      }
    }
    if (candidate.jobId && !seen.has(candidate.jobId)) out.push(candidate.jobId);
    return out;
  })();
  const job = jobs.find((j) => j.id === focusJobId);
  const latestApp = job ? getLatestAppForJob(candidate.applicationHistory, focusJobId) : null;
  const iv = job ? interviewEligibleForJob(candidate, focusJobId) : { ok: false };
  const roleLab = focusJobId ? portalStatusLabel(candidate, focusJobId) : "—";
  const prettyStatus = (s) => (s === "REATTMPT" ? "REATTEMPT" : s);
  const hrNote =
    latestApp?.hrDecisionStatus === "POTENTIAL"
      ? ""
      : latestApp?.hrRemarks != null && String(latestApp.hrRemarks).trim()
        ? String(latestApp.hrRemarks).trim()
        : "";
  const [rrCode, setRrCode] = useState("TECH_NETWORK");
  const [rrText, setRrText] = useState("");
  const [rrBusy, setRrBusy] = useState(false);
  const [clockTick, setClockTick] = useState(0);
  const schedAt = latestApp?.interviewScheduledAt;
  const schedSlot = schedAt ? interviewStartSlotStatus(schedAt, false) : null;
  const interviewCountdown =
    schedAt && schedSlot?.tooEarly ? formatInterviewCountdown(schedAt) : null;
  const interviewSlotClosed =
    schedAt && schedSlot?.tooLate && !latestApp?.interviewCompletedAt;
  useEffect(() => {
    if (!schedAt || latestApp?.interviewCompletedAt) return undefined;
    const id = setInterval(() => setClockTick((x) => x + 1), 1000);
    return () => clearInterval(id);
  }, [schedAt, latestApp?.interviewCompletedAt]);
  void clockTick;
  const canRequestReattempt = latestApp ? applicationEligibleForTechnicalReattemptRequest(latestApp) : false;
  const [rsCode, setRsCode] = useState("MISSED_EMERGENCY");
  const [rsText, setRsText] = useState("");
  const [rsBusy, setRsBusy] = useState(false);
  const canRequestReschedule = latestApp
    ? applicationEligibleForRescheduleRequest(latestApp, !!interviewSlotClosed)
    : false;
  const submitReschedule = async () => {
    if (!latestApp?.applicationId) return;
    setRsBusy(true);
    try {
      const r = await fetch("/api/voice-bot/reschedule-request", {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json", "X-Requested-With": "SwarHR", ...authHeaders() },
        body: JSON.stringify({
          applicationId: latestApp.applicationId,
          candidateReasonCode: rsCode,
          candidateReasonText: rsText.trim(),
        }),
      });
      const j = await r.json().catch(() => ({}));
      if (!r.ok) {
        toast.show({ tone: "danger", message: j.error || "Could not submit reschedule request" });
      } else {
        toast.show({ tone: "success", title: "Request submitted", message: "HR will review your missed-slot request. If approved, you can start the interview again — no fixed slot required." });
        setRsText("");
        if (typeof onSync === "function") await onSync();
      }
    } finally {
      setRsBusy(false);
    }
  };
  const submitReattempt = async () => {
    if (!latestApp?.applicationId) return;
    setRrBusy(true);
    try {
      const r = await fetch("/api/voice-bot/reattempt-request", {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json", "X-Requested-With": "SwarHR", ...authHeaders() },
        body: JSON.stringify({
          applicationId: latestApp.applicationId,
          candidateReasonCode: rrCode,
          candidateReasonText: rrText.trim(),
        }),
      });
      const j = await r.json().catch(() => ({}));
      if (!r.ok) {
        toast.show({ tone: "danger", message: j.error || "Could not submit request" });
      } else {
        toast.show({ tone: "success", title: "Request submitted", message: "HR will review and you will be notified here when approved." });
        setRrText("");
        if (typeof onSync === "function") await onSync();
      }
    } finally {
      setRrBusy(false);
    }
  };
  const canInterviewBtn =
    (roleLab === "SHORTLISTED" || roleLab === "APPLIED" || roleLab === "SCHEDULED") && iv.ok;
  const showInterviewBlock =
    (roleLab === "SHORTLISTED" || roleLab === "APPLIED" || roleLab === "SCHEDULED" || roleLab === "REATTMPT") && !iv.ok;
  return (
    <div className="min-h-dvh safe-bottom bg-surface-alt">
      {/* Single row on every size: stacking put a full-width Logout bar under
          the title on phones, which dominated the screen. */}
      {/* Header is the tightest row on a phone: title + badge + Logout. Trim the
          logo, title and vertical padding at phone size only; sm: and up keeps
          exactly what it had. */}
      <div className="bg-white border-b border-line text-ink-900 px-4 sm:px-6 py-2 sm:py-4 safe-top safe-x flex flex-row items-center justify-between gap-2 sm:gap-3">
        <div className="flex items-center gap-2 sm:gap-3 min-w-0">
          <div className="w-8 h-8 sm:w-9 sm:h-9 flex items-center justify-center shrink-0"><img src="/aira-logo.png" alt="AIRA" className="w-full h-full object-contain" /></div>
          <span className="font-bold text-sm sm:text-base truncate">Candidate Portal</span>
          <Badge compactOnMobile />
        </div>
        <button
          type="button"
          onClick={onLogout}
          /* Sign-out is a secondary action — the solid full-width red read as a
             warning and outranked the page content. Quieter treatment, matching
             the interview "End" button, with a 44px touch target kept on phones. */
          className="shrink-0 px-3 py-2 sm:py-1.5 min-h-[44px] sm:min-h-0 bg-red-50 hover:bg-red-100 text-red-600 border border-red-200 rounded-lg text-sm font-bold transition-colors inline-flex items-center justify-center gap-1.5"
        >
          <svg className="w-4 h-4 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" /></svg>
          Logout
        </button>
      </div>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-6 sm:py-8 safe-x">
        {/* Avatar beside the name at every size — stacking them cost a whole
            row on phones before any content was visible. */}
        {/* Space BETWEEN groups, not inside them: the blocks below each read as
            one unit, so the separation is what tells them apart on a phone. */}
        <div className="flex flex-row items-center gap-3 sm:gap-4 mb-6 sm:mb-5">
          <div className="w-11 h-11 sm:w-16 sm:h-16 bg-brand-600 rounded-2xl flex items-center justify-center text-white text-base sm:text-2xl font-black shrink-0">{candidate.name[0]}</div>
          <div className="min-w-0"><h1 className="text-lg sm:text-2xl font-black text-ink-900 break-words">{candidate.name}</h1><p className="text-ink-400 text-xs sm:text-sm truncate">{candidate.email}</p></div>
        </div>
        {jobIdsOrdered.length > 0 ? (
          <div className="mb-6 sm:mb-4">
            <p className="text-xs font-black text-ink-400 uppercase mb-3 sm:mb-2">Your applications</p>
            <div className="flex flex-wrap gap-2.5 sm:gap-2">
              {jobIdsOrdered.map((jid) => {
                const j = jobs.find((x) => x.id === jid);
                const lab = portalStatusLabel(candidate, jid);
                const sel = jid === focusJobId;
                return (
                  <button
                    key={jid}
                    type="button"
                    onClick={() => typeof onPortalFocusJob === "function" && onPortalFocusJob(jid)}
                    className={`inline-flex items-center gap-2 px-3.5 py-2.5 sm:px-3 sm:py-2 rounded-full border text-sm font-bold transition-all ${sel ? "bg-brand-600 text-white border-brand-600 shadow-md" : "bg-white text-ink-900 border-line hover:border-brand-300"}`}
                  >
                    <span>{j?.title || jid}</span>
                    <span className={`text-[10px] uppercase px-2 py-0.5 rounded-full ${SB[lab] || "bg-slate-100 text-ink-600"}`}>{prettyStatus(lab)}</span>
                  </button>
                );
              })}
            </div>
          </div>
        ) : null}
        {job ? (
          <div className="bg-white rounded-2xl border border-line shadow-sm p-4 sm:p-6 mb-6 sm:mb-4">
            <p className="text-xs font-black text-ink-400 uppercase mb-3">Selected role</p>
            <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-2 mb-4">
              <div className="min-w-0"><h2 className="text-lg sm:text-xl font-bold text-ink-900">{job.title}</h2><p className="text-ink-400 text-sm">{job.designation} · {job.location}</p></div>
              <span className={`text-xs font-black uppercase px-3 py-1.5 rounded-lg self-start shrink-0 ${SB[roleLab] || "bg-slate-100"}`}>{prettyStatus(roleLab)}</span>
            </div>
            {hrNote ? (
              <div className="bg-surface-alt rounded-xl p-4 mb-4"><p className="text-xs font-bold text-ink-400 mb-1">HR Remarks</p><p className="text-ink-600 text-sm italic">&quot;{hrNote}&quot;</p></div>
            ) : null}
            {getLatestAppForJob(candidate.applicationHistory, focusJobId)?.interviewScheduledAt ? (
              <p className={`text-xs font-bold text-teal-700 ${scheduleFlash && scheduleFlash.jobId === focusJobId && scheduleFlash.rescheduled ? "mb-1" : "mb-3"}`}>📅 Scheduled: {fmtDateTime(getLatestAppForJob(candidate.applicationHistory, focusJobId).interviewScheduledAt)}</p>
            ) : null}
            {scheduleFlash && scheduleFlash.jobId === focusJobId && scheduleFlash.rescheduled ? (
              <p className="text-xs font-semibold text-brand-700 mb-3">* Rescheduled to {fmtDateTime(scheduleFlash.at)}</p>
            ) : null}
            {latestApp?.interviewCompletionStatus === "incomplete_technical" ? (
              <div className="bg-amber-50 border border-amber-200 rounded-xl p-3 mb-3 text-xs text-amber-900">
                <p className="font-bold">Incomplete – technical / session issue</p>
                <p className="mt-1 text-amber-800">If the interview stopped due to network, mic, or device problems, you can request one reattempt after HR approves.</p>
              </div>
            ) : null}
            {latestApp?.reattemptRequestStatus === "pending" ? (
              <div className="bg-slate-100 border border-line rounded-xl p-3 mb-3 text-xs text-ink-600 font-semibold">✓ Under Review — reattempt request pending HR approval for this role.</div>
            ) : null}
            {latestApp?.reattemptRequestStatus === "approved" && latestApp?.interviewCompletionStatus === "not_started" ? (
              <div className="bg-green-50 border border-green-200 rounded-xl p-3 mb-3 text-xs text-green-800 font-semibold">HR approved a reattempt. You can start the interview again.</div>
            ) : null}
            {latestApp?.reattemptRequestStatus === "rejected" ? (
              <div className="bg-red-50 border border-red-100 rounded-xl p-3 mb-3 text-xs text-red-800">Your last reattempt request was not approved for this role. You may submit a new request if your situation changed.</div>
            ) : null}
            {canRequestReattempt ? (
              <div className="bg-white border border-brand-200 rounded-xl p-4 mb-3 space-y-2">
                <p className="text-xs font-black text-ink-400 uppercase">Request interview reattempt · this role</p>
                <Select value={rrCode} onChange={(e) => setRrCode(e.target.value)}>
                  {CANDIDATE_REATTEMPT_REASONS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
                </Select>
                <Textarea value={rrText} onChange={(e) => setRrText(e.target.value)} rows={2} placeholder="Short details (optional)" />
                <Button type="button" fullWidth loading={rrBusy} onClick={submitReattempt}>Submit request to HR</Button>
              </div>
            ) : null}
            {canInterviewBtn && interviewSlotClosed ? (
              <div className="space-y-2">
                <p className="w-full py-3 px-4 bg-amber-50 border border-amber-200 text-amber-900 text-sm font-semibold rounded-xl text-center leading-snug">{INTERVIEW_SLOT_CLOSED_MESSAGE}</p>
                {latestApp?.rescheduleRequestStatus === "pending" ? (
                  <div className="bg-slate-100 border border-line rounded-xl p-3 text-xs text-ink-600 font-semibold">✓ Under review — your missed-slot request is pending HR approval.</div>
                ) : null}
                {latestApp?.rescheduleRequestStatus === "rejected" ? (
                  <div className="bg-red-50 border border-red-100 rounded-xl p-3 text-xs text-red-800">Your last missed-slot request was not approved for this role. You may submit a new request if your situation changed.</div>
                ) : null}
                {canRequestReschedule ? (
                  <div className="bg-white border border-brand-200 rounded-xl p-4 space-y-2">
                    <p className="text-xs font-black text-ink-400 uppercase">Missed interview slot · this role</p>
                    <Select value={rsCode} onChange={(e) => setRsCode(e.target.value)}>
                      {CANDIDATE_RESCHEDULE_REASONS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
                    </Select>
                    <Textarea value={rsText} onChange={(e) => setRsText(e.target.value)} rows={2} placeholder="Short details (optional)" />
                    <Button type="button" fullWidth loading={rsBusy} onClick={submitReschedule}>Request another chance (missed slot)</Button>
                  </div>
                ) : null}
              </div>
            ) : canInterviewBtn && interviewCountdown ? (
              <button type="button" disabled className="w-full py-3 bg-slate-200 text-ink-600 font-bold rounded-xl cursor-not-allowed">Starts in {interviewCountdown}</button>
            ) : canInterviewBtn ? (
              <Button type="button" fullWidth size="lg" onClick={() => onInterview(candidate.id)}>🎤 Start Voice Interview →</Button>
            ) : showInterviewBlock ? (
              <p className="text-xs text-ink-400 mb-2">{iv.reason}</p>
            ) : null}
            {roleLab === "INTERVIEWED" && <div className="bg-teal-50 border border-teal-200 rounded-xl p-4 text-center mt-3"><p className="text-teal-700 font-bold text-sm">✓ Under Review</p></div>}
            {roleLab === "REJECTED" && <div className="bg-red-50 border border-red-200 rounded-xl p-4 text-center mt-3"><p className="text-red-700 font-bold text-sm">Not Selected — this role</p></div>}
          </div>
        ) : (
          <div className="bg-white rounded-2xl border-2 border-dashed border-line p-6 sm:p-10 text-center mb-4"><p className="text-ink-400 mb-4">No active application.</p><Button className="w-full sm:w-auto" onClick={onApply}>Browse Jobs</Button></div>
        )}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <Button type="button" variant="secondary" fullWidth onClick={onApply}>Browse Jobs</Button>
          <button type="button" onClick={onTalentPool} className={`w-full py-3 bg-gradient-to-r from-brand-50 to-brand-50 border text-brand-700 font-bold rounded-xl text-sm ${talentPoolSelected ? "ring-2 ring-brand-400 border-brand-300" : "border-brand-200"}`}>🌟 Talent Pool</button>
        </div>
      </div>
    </div>
  );
}

